import { auth } from '../../firebase';
import React, { useState } from 'react';

function ResetPassword() {
    const [message, setMessage] = useState("")
    const [email, setEmail] = useState("")

    function submitHandler() {
        if (email) {
            const trimmedEmail = email.trim();
            auth.sendPasswordResetEmail(trimmedEmail).then(() => {
                setMessage("Epost sendt til din oppgitte adresse");
            }).catch(err => {
                setMessage("Noe gikk galt, prøv igjen")
                console.log(err)
            })
        }

    }
    return (
        <React.Fragment>
            <h4 className="text-white font-weight-bold">Resett passord</h4>
            <div className="md-form">
                {email && <label className="text-light mb-5">Din epost</label>}
                <input className="form-control mb-2 text-white bgLight" value={email} onChange={e => setEmail(e.target.value)} placeholder="Din epost" />
            </div>
            {message && <div className="alert alert-success">{message}</div>}
            <button onClick={submitHandler} className="btn btn-block btn-success">Send</button>
        </React.Fragment>
    )

}
export default ResetPassword